import { IBlock } from "../../../framework/src/IBlock"
import { Message } from "../../../framework/src/Message"
import { BlockComponent } from "../../../framework/src/BlockComponent"
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum"
import { runEngine } from "../../../framework/src/RunEngine"

// Customizable Area Start
import DOMPurify from "dompurify"
import { scrollToTop } from "../../../components/src/utils"
// Customizable Area End

export const configJSON = require("./config")

// Customizable Area Start
// Customizable Area End
export interface Props {
  navigation: any
  id: string
  // Customizable Area Start
  // Customizable Area End
}

interface S {
  // Customizable Area Start
  isLoading: boolean
  isInfoDialog: boolean
  privacyPolicy: string
  // Customizable Area End
}

interface SS {
  id: string
  // Customizable Area Start
  // Customizable Area End
}

export default class PrivacyPolicyController extends BlockComponent<
  Props,
  S,
  SS
> {
  // Customizable Area Start
  privacyPolicyApiCallId: string = ""
  // Customizable Area End

  constructor(props: Props) {
    super(props)
    this.receive = this.receive.bind(this)

    this.subScribedMessages = [
      // Customizable Area Start
      getName(MessageEnum.SessionResponseMessage),
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.NavigationPayLoadMessage),
      // Customizable Area End
    ]

    this.state = {
      // Customizable Area Start
      isLoading: false,
      isInfoDialog: false,
      privacyPolicy: ""
      // Customizable Area End
    }
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages)

    // Customizable Area Start
    // Customizable Area End
  }

  // Customizable Area Start
  async componentDidMount() {
    scrollToTop(true)
    this.privacyPolicyApi()
  }

  handleCloseInfoDialog = () => {
    this.setState({ isInfoDialog: false })
  }

  async receive(_from: string, message: Message) {
    const apiRequestCallId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    )

    const responseJson = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    )

    if (apiRequestCallId === this.privacyPolicyApiCallId) {
      if ("data" in responseJson && responseJson.data.length > 0) {
        const latestTermsAndCons = responseJson.data[0]
        this.setState({
          isLoading: false,
          privacyPolicy: DOMPurify.sanitize(
            latestTermsAndCons.description
          ),
        })
      } else {
        this.setState({
          isLoading: false,
          isInfoDialog: true,
        })
      }
    }
  }

  privacyPolicyApi = async () => {
    this.setState({ isLoading: true })

    const header = {
      "Content-Type": configJSON.apiContentType,
    }

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    )

    this.privacyPolicyApiCallId = requestMessage.messageId

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.privacyPolicyApiEndpoint
    )

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    )

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.getApiMethod
    )

    runEngine.sendMessage(requestMessage.id, requestMessage)
  }
  // Customizable Area End
}
